module.exports = __webpack_public_path__ + "img/mine_hk.ce71d7ca.gif";